export const GET_VIDEO_PLAY_DATA = 'Video/get_video_play_data'
export const SET_VIDEO_PLAY_DATA = 'Video/set_video_play_data'
